@if (loading) {
  <app-instant-checkup-loader class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center" />
}
<ng-container *ngIf="!loading">
  <header class="tw-flex-none tw-w-full">
    <div class="tw-bg-black tw-h-14 tw-px-6 tw-flex tw-items-center tw-w-full tw-justify-center tw-z-[100]"  [class]="{'tw-bg-gray-800': acqRebranding2025, 'tw-bg-black': !acqRebranding2025, 'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}">
      <div class="tw-absolute tw-left-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-h-10 tw-w-10"
           [class]="{'tw-bg-gray-800': acqRebranding2025, 'tw-bg-black': !acqRebranding2025}"
           (click)="back()">
        <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
                 [iconName]="'arrow_back'"></cs-icon>
      </div>
      @switch (headerType) {
        @case (HeaderTypeEnum.SKIN_ANALYSIS_RESULT) {
          <span class="tw-font-bold tw-text-300 tw-text-white"
                i18n="@@skinAnalysisResult">Skin analysis result</span>
        }
        @case (HeaderTypeEnum.HAIR_ANALYSIS_RESULT) {
          <span class="tw-font-bold tw-text-300 tw-text-white"
                i18n="@@hairAnalysisResult">Hair analysis result</span>
        }
        @case (HeaderTypeEnum.DATE) {
          <span class="tw-text-300 tw-text-white">{{ today | date:'MMMM d, y' }}</span>
        }
        @case (HeaderTypeEnum.CURESKIN_LOGO) {
          <img src="https://cdn.cureskin.com/app/img/cureskin-logo.png"
               alt="Cureskin Logo"
               class="tw-w-full tw-h-full tw-max-w-[90px] tw-max-h-4">
        }
        @default {
          <span class="tw-font-bold tw-text-300 tw-text-white"
                i18n="@@skinAnalysisResult">Skin analysis result</span>
        }
      }
      @if (!isFollowUpReportPending) {
        <div
             class="tw-absolute tw-right-6 tw-top-2 tw-flex tw-items-center tw-justify-center tw-rounded-xl tw-h-10 tw-w-10"
             [class]="{'tw-bg-gray-800': acqRebranding2025, 'tw-bg-black': !acqRebranding2025}">
          <cs-icon class="tw-h-10 tw-w-10"
                   [iconName]="'delete'"
                   (click)="deleteInstantCheckup()">
          </cs-icon>
        </div>
      }
    </div>
  </header>
  <!-- Detections selection pills -->
  <!-- Here - !['HAIR_FRONT'].includes(instantCheckup.type) is an unnecessary check because for results will be undefined if it is hair front - logic is in component-->
  <!-- Hide tabs for HAIR_TOP type (scalp-segment) -->
  <section *ngIf="results?.length && ![appConfig.Shared.InstantCheckup.Type.HAIR_FRONT, appConfig.Shared.InstantCheckup.Type.HAIR_TOP].includes(instantCheckup.type)"
           class="tw-flex-none tw-flex tw-items-center tw-gap-1 tw-py-2 tw-pl-4 tw-z-10 tw-overflow-x-scroll tw-backdrop-blur tw-bg-gray-100">
    <div class="tw-flex tw-items-center tw-justify-center tw-font-body tw-text-300 tw-text-gray-900 tw-bg-gray-50 tw-rounded-full tw-h-10 tw-px-4 tw-w-max tw-whitespace-nowrap tw-transition-all tw-shadow-z1"
         [ngClass]="{
                      'tw-text-gray-50': !selectedDetection?.class,
                      'tw-bg-gray-50 tw-text-gray-900': !!selectedDetection?.class,
                      'tw-bg-black': !selectedDetection?.class && !acqRebranding2025,
                      'tw-bg-gray-800': !selectedDetection?.class && acqRebranding2025,
                      'tw-font-lexend tw-h-[37px]': acqRebranding2025,
                      'tw-font-body tw-h-10': !acqRebranding2025
                    }"
         (click)="selectedDetection = null; slide();  slide(swiperRefOverlay); redrawScaledCanvas(zoomBox)"
         i18n="@@allConcerns">
      All
    </div>
    <div *ngFor="let detection of results"
         class="tw-flex tw-items-center tw-justify-center tw-font-body tw-text-300 tw-text-gray-900 tw-bg-gray-50 tw-rounded-full tw-h-10 tw-px-4 tw-w-max tw-whitespace-nowrap tw-transition-all tw-shadow-z1"
         [ngClass]="{
                      'tw-text-gray-50': detection?.class === selectedDetection?.class,
                      'tw-bg-gray-50 tw-text-gray-900': detection?.class !== selectedDetection?.class,
                      'tw-bg-black': (detection?.class === selectedDetection?.class) && !acqRebranding2025,
                      'tw-bg-gray-800': (detection?.class === selectedDetection?.class) && acqRebranding2025,
                      'tw-font-lexend tw-h-[37px]': acqRebranding2025,
                      'tw-font-body tw-h-10': !acqRebranding2025
                    }"
         [appScrollToView]="detection?.class === selectedDetection?.class"
         (click)="selectedDetection = detection; slide();  slide(swiperRefOverlay); redrawScaledCanvas(zoomBox)">
      {{ problemsCopy[user?.get('languagePreference') || 'en'][detection.class]?.name}}
    </div>
  </section>

  @if (hairAiDetectionTealColor() && showDetectionViewTab() && isHairTopType && hasScalpDetections()) {
    <section class="tw-absolute tw-top-[68px] tw-left-2 tw-w-fit tw-rounded-full tw-flex-none tw-flex tw-items-center tw-gap-1 tw-p-0.5 tw-z-10 tw-font-lexend tw-overflow-x-scroll tw-backdrop-blur tw-bg-gray-50">
        <div class="tw-absolute tw-top-0.5 tw-bottom-0.5 tw-rounded-full tw-ease-out tw-z-0"
             [class.tw-bg-black]="!acqRebranding2025"
             [class.tw-bg-gray-800]="acqRebranding2025"
             [style.left.px]="scalpIndicatorLeft()"
             [style.width.px]="scalpIndicatorWidth()"
             [style.transition]="'left ' + SCALP_INDICATOR_TRANSITION_MS + 'ms ease-out, width ' + SCALP_INDICATOR_TRANSITION_MS + 'ms ease-out'"></div>
        <div #scalpFilledPill
             class="tw-min-w-16 tw-relative tw-z-10 tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-rounded-full tw-py-1 tw-whitespace-nowrap"
             [style.transition]="'color ' + SCALP_INDICATOR_TRANSITION_MS + 'ms ease-out'"
             [ngClass]="getScalpPillClasses(appConfig.Shared.InstantCheckup.Detections.View.FILLED)"
             (click)="applyScalpViewMode(appConfig.Shared.InstantCheckup.Detections.View.FILLED, 'toggle')"
             i18n="@@filled">
          Filled
        </div>
        <div #scalpOutlinedPill
             class="tw-min-w-16 tw-relative tw-z-10 tw-flex tw-items-center tw-justify-center tw-font-body tw-text-200 tw-rounded-full tw-py-1 tw-px-2.5 tw-whitespace-nowrap"
             [style.transition]="'color ' + SCALP_INDICATOR_TRANSITION_MS + 'ms ease-out'"
             [ngClass]="getScalpPillClasses(appConfig.Shared.InstantCheckup.Detections.View.OUTLINE)"
             (click)="applyScalpViewMode(appConfig.Shared.InstantCheckup.Detections.View.OUTLINE, 'toggle')"
             i18n="@@outlined">
          Outlined
        </div>
    </section>
  }

    @if (fromSelfCheckupBanner) {
      <div class="tw-overflow-hidden tw-whitespace-nowrap tw-bg-teal-100 tw-text-200 tw-font-body tw-text-teal-600 tw-font-semibold">
        <div class="tw-flex tw-w-max">
          <div class="tw-flex tw-min-w-max">
            <div *ngFor="let item of [0,1,2,3,4]"
                 class="tw-w-max tw-px-4 tw-py-2 tw-text-center tw-animate-marquee"
                 i18n="@@doctorWillCreateYourReport">Your doctor will use this photo to create a detailed progress report.
            </div>
          </div>
        </div>
      </div>
    }

  @if (showPhotoReviewDisclaimer) {
    <div class="tw-font-body tw-font-bold tw-text-100">
      <ng-container *ngIf='instantCheckupStatusBannerState === InstantCheckupStatusBannerStateEnum.PHOTO_REVIEWED'>
        <div class="tw-px-4 tw-text-orange-400 tw-bg-orange-100 tw-font-bold tw-py-2 tw-w-full tw-text-center"
             i18n="@@photoReviewed"> This photo was last reviewed by your dermatologist on
          {{user.get('refreshDate') | date: 'dd MMM yyyy'}}. </div>
      </ng-container>
      <ng-container
                    *ngIf='instantCheckupStatusBannerState === InstantCheckupStatusBannerStateEnum.PHOTO_REVIEW_PENDING'>
        <div class="tw-px-4 tw-text-orange-400 tw-bg-orange-100 tw-font-bold tw-py-2 tw-w-full tw-text-center"
             i18n="@@photoReviewPending"> This photo is pending review by your dermatologist. </div>
      </ng-container>
      <ng-container
                    *ngIf='instantCheckupStatusBannerState === InstantCheckupStatusBannerStateEnum.PHOTO_WILL_BE_REVIEWED'>
        <div class="tw-px-4 tw-text-orange-400 tw-bg-orange-100 tw-font-bold tw-py-2 tw-w-full tw-text-center"
             i18n="@@photoWillBeReviewedNew"> Your assigned CureSkin dermatologist will review this photo after you
          order the treatment kit. </div>
      </ng-container>
    </div>
  }
  <!-- Canvas drawing area -->
  <main #main
        class="tw-flex-auto tw-flex tw-flex-col tw-max-w-full tw-overflow-hidden tw-bg-black">
    <div #zoomBox
         class="tw-relative tw-h-full tw-w-full tw-transition-all transition tw-duration-300 tw-ease-in-out"
         (click)="toggleScalpView()">
      <canvas #imageCanvas
              class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full"
              [appDrawImage]="image"
              [faceLandmarks]="faceLandmarks"
              (croppingConfig)="croppingConfig = $event"></canvas>
      <ng-container *ngFor="let detection of results; even as isEven;">
        <canvas class="tw-absolute tw-left-0 tw-top-0 tw-transition-all"
                [ngClass]="{
                                                  'tw-animate-fade_in_right': isEven && !selectedDetection,
                                                  'tw-animate-fade_in_left': !isEven && !selectedDetection,
                                                  'tw-animate-fade_out_right': isEven && selectedDetection && detection?.class !== selectedDetection?.class,
                                                  'tw-animate-fade_out_left': !isEven && selectedDetection && detection?.class !== selectedDetection?.class,
                                                }"
                [height]="imageCanvas?.clientHeight"
                [width]="imageCanvas?.clientWidth"
                [appDrawDetections]="detection"
                [config]="croppingConfig"
                [filled]="isScalpFilledView()"
                [outlineLineWidth]="isDetectionOutlined() ? 2 : null"
                [class.tw-drop-shadow-mint-glow]="shouldShowMintGlow(detection)"></canvas>
      </ng-container>
      <swiper #swiperRefOverlay
              class="tw-absolute tw-left-0 tw-top-0 tw-transition-all tw-h-full tw-w-full"
              (slideChange)="selectDetection($event); slide(); redrawScaledCanvas(zoomBox);">
        <div *swiperSlide
             class="tw-h-full tw-w-full"></div>
        <ng-container *ngFor="let detection of results;">
          <div *swiperSlide
               class="tw-h-full tw-w-full"></div>
        </ng-container>
      </swiper>
      <ng-container *ngIf="blurWithConcernsDetected && handleBlurPhotosExperiment">
        <div
             class="tw-absolute tw-top-3 tw-left-3 tw-right-3 tw-bg-orange-50 tw-border tw-border-orange-400 tw-px-4 tw-py-1 tw-mb-4 tw-text-left tw-rounded-lg tw-flex tw-justify-start tw-items-start">
          <img src="/assets/icons/warning.svg"
               alt="warning_icon"
               class="tw-w-4 tw-h-4 tw-mr-1" />
          <h1 i18n="@@unclearImageError"
              class="tw-text-orange-400 tw-text-200 tw-font-body tw-font-bold">Image not clear, it is advised to retake
            photo</h1>
        </div>
      </ng-container>
    </div>
  </main>
  <!-- Detection card carousel -->
  <footer *ngIf="showFooter"
          class="tw-flex-none tw-pb-1 tw-h-18 tw-bg-gray-100 tw-overflow-visible">
    <swiper *ngIf="['LEFT_SIDE_FACE', 'FRONT_FACE', 'RIGHT_SIDE_FACE'].includes(instantCheckup.type)"
            #swiperRef
            [config]="carouselConfig"
            class="-tw-mt-44 tw-px-4 tw-h-60 tw-overflow-visible tw-relative"
            (slideChange)="selectDetection($event); slide(swiperRefOverlay); redrawScaledCanvas(zoomBox);">
      <div *swiperSlide
           class="tw-px-6 tw-py-4 tw-mr-3 tw-box-border tw-bg-white tw-rounded-xl tw-z-20 tw-h-[136px] tw-overflow-hidden tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-transition-all tw-duration-200 tw-ease-in-out"
           [ngClass]="!selectedDetection?.class ? 'tw-shadow-z3': ''"
           (click)="selectDetection({activeIndex: 1}); slide(swiperRef)">
        <div [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}">
          @if (headerType === HeaderTypeEnum.CURESKIN_LOGO || headerType === HeaderTypeEnum.DATE) {
            <span class="tw-font-bold tw-text-500 tw-mb-1"
                  i18n="@@skinAnalysisResult">Skin analysis result</span>
          } @else {
            <span class="tw-font-bold tw-text-500 tw-mb-1"
                  i18n="@@summary"> Summary </span>
          }
          <div class="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-mb-1">
            <h1 class="tw-text-yellow-400 tw-text-200 tw-font-bold"
                i18n="@@concernsDetected">
              {{results.length}}&nbsp;<span *ngIf="results.length === 1">Concern</span><span *ngIf="results.length !== 1">Concerns</span> Detected
            </h1>
          </div>
          <ng-container *ngIf="!responsiveCardReadMoreExperiment">
            <span class="tw-text-200 tw-text-gray-700 tw-h-[54px] tw-text-ellipsis">
              <ng-container *ngFor="let item of results; let isLast = last;">
                {{ problemsCopy[user?.get('languagePreference') ||
                                    'en'][item?.class]?.name }}<span *ngIf="!isLast">, </span>
              </ng-container>
            </span>
          </ng-container>
          <ng-container *ngIf="responsiveCardReadMoreExperiment">
            <app-read-more class="tw-font-body tw-text-200"
                           [isExpanded]="summaryExpanded"
                           [text]="summaryFullText"></app-read-more>
          </ng-container>
        </div>
      </div>
      <ng-container *ngFor="let item of results; let i = index">
        <div *swiperSlide
             class="tw-px-6 tw-py-4 tw-mr-3 tw-box-border tw-bg-white tw-rounded-xl tw-z-20 tw-overflow-hidden tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-transition-all tw-duration-200 tw-ease-in-out"
             [ngClass]="(selectedDetection?.class === item?.class ? 'tw-shadow-z3 tw-bg-white' : 'tw-bg-gray-100') + ' ' + (expandedItems[i] ? 'tw-h-fit' : 'tw-h-[136px]')">
          <div
               class="tw-font-bold tw-text-500 tw-mb-1 tw-line-clamp-1 tw-overflow-hidden tw-text-ellipsis" [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}">
            {{ problemsCopy[user?.get('languagePreference') ||
                            'en'][item?.class]?.name }}
          </div>
          <div class="tw-flex tw-items-center tw-justify-start tw-gap-1 tw-mb-1 tw-leading-4">
            <h1 class="tw-font-body tw-text-200 tw-font-bold"
                [ngClass]="{
                  'tw-font-lexend': acqRebranding2025,
                  'tw-font-body': !acqRebranding2025,
                  'tw-text-gray-400': item?.severity === concernSeverity.Mild,
                  'tw-text-yellow-400': item?.severity === concernSeverity.Moderate,
                  'tw-text-orange-500': item?.severity === concernSeverity.Severe,
            }">
              {{concernSeverityTranslations?.[user?.get('languagePreference')
                                          ||'en']?.[item?.severity]}}
            </h1>
            <cs-icon *ngIf="item?.severity === concernSeverity.Severe"
                     class="tw-w-[13px] tw-h-[13px]"
                     [iconName]="'severe-vector'"></cs-icon>
          </div>
          <div>
            <ng-container *ngIf="!responsiveCardReadMoreExperiment">
              <div
                   class="tw-text-200 tw-h-[54px] tw-text-gray-700 tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis"  [class]="{'tw-font-lexend': acqRebranding2025, 'tw-font-body': !acqRebranding2025}">
                {{problemsCopy[user?.get('languagePreference')
                                  ||'en'][item?.class]?.info}}
              </div>
            </ng-container>
            <app-read-more *ngIf="responsiveCardReadMoreExperiment"
                           class="tw-font-body tw-text-200"
                           [isExpanded]="expandedItems[i]"
                           [text]="problemsCopy[user?.get('languagePreference')
                                    || this.appConfig.Shared.Languages.EN][item?.class]?.info"></app-read-more>
          </div>
        </div>
      </ng-container>
    </swiper>
    <!-- HAIR_TOP scalp-segment card -->
    <div *ngIf="isHairTopType && (hasScalpDetections() || showNoScalpDetectionCard)" [ngClass]="hasScalpDetections() ? '-tw-mt-15' : '-tw-mt-20'" class="tw-px-4 tw-overflow-visible tw-relative">
      <div [ngClass]="hasScalpDetections() ? 'tw-h-[136px]' : 'tw-h-fit tw-min-h-[136px]'" class="tw-px-5 tw-shadow-z3 tw-py-4 tw-box-border tw-bg-white tw-rounded-xl tw-z-20 tw-overflow-visible tw-font-body">
        <div class="tw-font-bold tw-text-500 tw-mb-1 tw-line-clamp-1 tw-overflow-hidden tw-text-ellipsis">
          @if (hasScalpDetections()) {
            {{ problemsCopy[user?.get('languagePreference') || 'en']['scalp-segment']?.name }}
          } @else {
            <span i18n="@@noVisibleScalpArea">No visible scalp area</span>
          }
        </div>
        <div [ngClass]="{'tw-line-clamp-4': hasScalpDetections(), 'tw-line-clamp-none': !hasScalpDetections()}" class="tw-text-200 tw-text-gray-700 tw-overflow-hidden tw-text-ellipsis">
          @if (hasScalpDetections()) {
            <p *ngIf="user?.get('Gender') === ApiClientConstant.User.Gender.FEMALE" i18n="@@scalpDetectionDescFemale">Scalp visibility along hair partition is common. But, if the partition appears wider than usual, it indicates increased hair fall or thinning.</p>
            <p *ngIf="user?.get('Gender') === ApiClientConstant.User.Gender.MALE" i18n="@@scalpDetectionDescMale">Scalp visibility along hair partition is common. But, increased visibility around the hairline/crown may indicate progressive hair thinning or baldness.</p>
          } @else {
            <div [ngClass]="[appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')) ? 'tw-text-100' : 'tw-text-200'">
              <div class="tw-font-semibold tw-mb-1" i18n="@@possibleReasons">Possible Reasons:</div>
              <ul class="tw-list-disc tw-list-inside tw-space-y-0.5">
                <li i18n="@@highHairDensity">Hair density is high with minimal scalp visibility</li>
                <li i18n="@@unclearTopViewPhoto">The top-view photo isn't clear</li>
                <li i18n="@@lightingOrBlurIssue">Low or excess lighting or blur photo</li>
                <li i18n="@@hairTopNotPresent">Hair top not present in photo</li>
              </ul>
            </div>
          }
        </div>
      </div>
    </div>
    <div *ngIf="['HAIR_FRONT'].includes(instantCheckup.type)"
         [ngClass]="[appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')) ? '-tw-mt-18' : '-tw-mt-15'"
         class="tw-px-4 tw-overflow-visible tw-relative">
      <div *ngIf="isTempleBaldnessDetected"
           class="tw-px-6 tw-shadow-z3 tw-py-4 tw-box-border tw-min-h-[136px] tw-bg-white tw-rounded-xl tw-z-20 tw-overflow-visible">
        <div class="tw-font-body tw-font-bold tw-text-500 tw-mb-1" i18n="@@templeBaldness">
          Temple Baldness
        </div>
        <div class="tw-font-body tw-text-200 tw-text-gray-700 tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis" i18n="@@thiningOrLossOfHair">
          Thinning or loss of hair on forehead sides.
        </div>
        <div
             class="tw-font-body tw-text-200 tw-text-gray-700 tw-h-[54px] tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis">
          <span i18n="@@causesOfHairfall">Causes: genetics, hormones, aging, stress or diet</span>
        </div>
      </div>
      <div *ngIf="!isTempleBaldnessDetected && isShowHairlineDetectionExperiment&& isHairlineDetected"
           [ngClass]="[appConfig.Shared.Languages.KN, appConfig.Shared.Languages.TE, appConfig.Shared.Languages.TA].includes(user.get('languagePreference')) ? 'tw-py-2' : 'tw-pt-4 tw-pb-2'"
           class="tw-px-6 tw-shadow-z3 tw-box-border tw-min-h-[136px] tw-bg-white tw-rounded-xl tw-z-20 tw-overflow-visible">
        <div class="tw-font-body tw-font-bold tw-text-500 tw-mb-1" i18n="@@hairlineDetected">
          Hairline Detected
        </div>
        <div class="tw-font-body tw-text-200 tw-text-gray-700 tw-line-clamp-3 tw-overflow-hidden tw-text-ellipsis" i18n="@@perfectMaleHairline">
          A perfect male hairline is typically straight or slightly rounded, with no
          significant recession at the temples.
        </div>
        <hr class="tw-my-2">
        <div class="tw-font-body tw-text-100 tw-text-yellow-400 tw-overflow-hidden"
             [routerLink]="['/instant-checkup/preview']"
             [queryParams]="{tag: 'HAIR_FRONT'}">
          <span i18n="@@forBetterDetection">For better detection, comb your hair back</span> <b class="tw-ml-1" i18n="@@seeHow">(See How)</b>
        </div>
      </div>
    </div>
  </footer>
  <ng-container *ngIf="blurWithoutConcernsDetected && handleBlurPhotosExperiment">
    <div class="tw-h-14">
      <div [ngClass]="(user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'te' || user.get('languagePreference') === 'kn') ? '-tw-translate-y-[117px]': '-tw-translate-y-[85px]'"
           class="tw-w-[90%] mx-auto tw-left-5 tw-right-5 tw-bg-orange-50 tw-border tw-border-orange-400 tw-px-4 tw-py-4 tw-mb-4 tw-text-left tw-rounded-xl">
        <div class="tw-flex tw-justify-start tw-items-start tw-mb-2">
          <img src="/assets/icons/warning.svg"
               class="tw-w-4 tw-h-4 tw-mr-1 tw-mt-0.5"
               alt="warning_icon" />
          <h1 i18n="@@imageNotClear"
              class="tw-text-orange-400 tw-text-400 tw-font-body tw-font-bold">Image Not Clear</h1>
        </div>
        <h1 i18n="@@retakePhoto"
            class="tw-text-200 tw-mb-2">Retake photo, by trying the following things:</h1>
        <div class="tw-text-200 tw-pl-2">
          <h1>1. <span i18n="@@cleanCamera">Clean your camera</span></h1>
          <h1>2. <span i18n="@@dontMove">Don't move while taking picture</span> </h1>
          <h1>3. <span i18n="@@useBackCamera">Use back camera</span></h1>
        </div>
      </div>
    </div>
  </ng-container>
  @if (instantCheckup && isInvalidPhoto) {
    <app-invalid-photo-error-card [uiCode]="resolvedInvalidPhotoUiCode" />
  }

  <!-- Footer buttons -->
  <footer class="tw-px-3 tw-bg-gray-100"
          [ngClass]="instantCheckup && isInvalidPhoto ? 'tw-pb-5' : 'tw-py-5'">
    <div [ngClass]="footerLayout.containerVariant === FooterContainerVariant.DEFAULT
            ? 'tw-flex tw-gap-3'
            : 'tw-w-full tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-2'">
      @for (button of footerLayout.buttons; track button.i18nKey) {
        @if (button.shouldShow) {
          <div class="tw-flex-1 tw-rounded-3 tw-font-semibold tw-flex tw-justify-center tw-items-center tw-font-body tw-py-3"
               [ngClass]="[button.cssClasses, footerLayout.containerVariant === FooterContainerVariant.DEFAULT ? 'tw-h-[48px]' : '']"
               (click)="button.action()">
            @switch (button.i18nKey) {
              @case (I18nKey.RE_TAKE_PHOTO) {
                <span i18n="@@reTakePhoto">Re-Take Photo</span>
              }
              @case (I18nKey.CHECK_AGAIN) {
                <span i18n="@@checkAgain">Check Again</span>
              }
              @case (I18nKey.RETAKE) {
                <span i18n="@@retake">Retake</span>
              }
              @case (I18nKey.CONTINUE) {
                <span i18n="@@continue">Continue</span>
              }
              @case (I18nKey.CHANGE) {
                <span i18n="@@change">Change</span>
              }
              @case (I18nKey.SHARE_WITH_DOCTOR) {
                <span i18n="@@shareWithDoctor">Share with Doctor</span>
              }
            }
          </div>
        }
      }
    </div>
  </footer>
</ng-container>

<pop-up-modal [config]="ui.popUpModal"
              (close)="popUpClosed($event)"></pop-up-modal>

<input class="tw-fixed"
       #cameraInput=""
       id="cameraInput"
       type="file"
       capture="user"
       accept="image/*"
       (change)="uploadImageFromNativeCamera($event)"
       style="top: -100%; left: -100%" />
